import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export type ClientSession = {
  id: number;
  worker_id: number;
  platform: 'ios' | 'android';
  binary_version: string;
  ota_hash: string;
  first_seen_at: string;
  last_seen_at: string;
};

export type Pagination = {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
};

export type ClientSessionListResponse = {
  success: boolean;
  data: ClientSession[];
  pagination: Pagination;
};

export async function fetchFleetClientSessions(params: {
  page?: number;
  per_page?: number;
  platform?: string;
  binary_version?: string;
}): Promise<ClientSessionListResponse> {
  const res = await api.get<ClientSessionListResponse>(
    '/api/admin/client_sessions',
    { params },
  );
  return res.data;
}

export async function fetchWorkerClientSessions(
  workerId: number,
): Promise<ClientSessionListResponse> {
  const res = await api.get<ClientSessionListResponse>(
    `/api/admin/workers/${workerId}/client_sessions`,
  );
  return res.data;
}
